import { Component, Input, OnInit, inject } from '@angular/core';
import { Help } from '@shared/models/help/help';
import { BsModalRef } from 'ngx-bootstrap/modal';


import { TranslateModule } from '@ngx-translate/core';
import { SafeHTMLPipe } from '@shared/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'app-help-modal',
    templateUrl: './help-modal.component.html',
    styleUrls: ['./help-modal.component.scss'],
    standalone: true,
    imports: [TranslateModule, SafeHTMLPipe]
})
export class HelpModalComponent implements OnInit {
    protected readonly bsModalRef = inject(BsModalRef);
    @Input() help!: Help;

    ngOnInit() {
        console.log(this.help);
    }

    close(): void {
        this.bsModalRef.hide();
    }
}
